import axios from ".";
import { SEND_LOGGER } from "../resources/constants";

export default class logger {
  public static async set(data: any) {
    return await axios.post(SEND_LOGGER, data);
  }
}
